import * as React from "react";
import {ChangeEvent} from "react";
import {InputFieldState} from "../../shared/helpers/InputFieldState";

interface SelectProps {
    label: string;
    state: InputFieldState
    onChange?: (value: string, event: ChangeEvent<HTMLSelectElement>, option: any) => void;
    options?: string[] | any;
}

export type Option = {
    key: string,
    value: string | number
}

/**
 * Drop Down Select Element
 */
export class Select extends React.Component<SelectProps> {

    public static defaultProps = {
        label: "Label"
    };

    render() {
        return <label className="bold">{this.props.label}<select onChange={(event) => {

            let entry = null;
            Object.keys(this.props.options).map(key => {
                if (this.props.options[key].key == event.target.value) {
                    entry = this.props.options[key];
                }
            });
            this.props.onChange && this.props.onChange(event.target.value, event, entry);
        }} value={this.props.state.value as string}>
            {Object.keys(this.props.options).map(key => <option key={key}
                                                                value={this.props.options[key].key}>{this.props.options[key].value}</option>)}
        </select>
            <div className="error_message">{this.props.state.errorMessage}</div>
        </label>
    }

    setOptions(options: any) {
        this.setState({options: options});
    }
}
